exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".AgreementTextBox {\n  color: #333;\n  font-size: 0.14rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.3);\n  width: 100vw;\n  height: 100vh;\n}\n.AgreementTextBox > div {\n  padding: 0.16rem;\n  background: #fff;\n  width: calc(100% - 0.5rem);\n  height: calc(100% - 0.6rem);\n  position: relative;\n  top: 0.3rem;\n  left: 0.25rem;\n}\n.AgreementTextBox > div h1 {\n  font-size: 0.19rem;\n  line-height: 0.26rem;\n  text-align: center;\n}\n.AgreementTextBox > div div {\n  line-height: 0.2rem;\n}\n.AgreementTextBox > div p {\n  line-height: 0.2rem;\n  font-weight: bold;\n}\n.AgreementTextBox > div .am-button-primary {\n  margin: 0.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/authCertificate/modules/agreementText/index.less
// module id = 856
// module chunks = 0